import {z} from 'zod';

import {AvailableDiscountSchema, DiscountSourceTypeSchema} from '@dms/api/shared';

export const EditMaterialItemFormSchema = z.object({
  neededAt: z.date().nullish(),
  quantity: z.number(),
  sellingPricePerUnit: z.number(),
  defaultSupplierDiscountGroup: z.string().nullish(),
  vatType: z.string(),
  vatFreeCode: z.string().nullish(),
  mechanic: z.string().nullish(),
  isUnitPriceWithVat: z.boolean(),
  isCustomPrice: z.boolean(),
  discount: z.object({
    isDoNotApplyDiscount: z.boolean(),
    isDiscountEnable: z.boolean(),
    discountSourceType: DiscountSourceTypeSchema.nullish(),
    discountRate: z.number().nullish(),
    availableDiscounts: z.array(
      AvailableDiscountSchema.extend({discountRate: z.number().min(0).max(100).nullish()})
    ),
  }),
  isOneTimeSale: z.boolean(),
});

export type EditMaterialItemForm = z.infer<typeof EditMaterialItemFormSchema>;
